import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.stats-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--stats-slider' )[0], {
          // type: 'fade',
          pagination: true,
          arrows: true,
          gap: '0px',
          perPage: 1,
          autoWidth: false,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'stats-slider', COMPONENT );
} )( app );
